// extracted by mini-css-extract-plugin
export default {"tupacGrid":"An-z","tupacHeader":"Bn-z","tupacHeader2":"Cn-z","tupacMenu":"Dn-z","tupacMenu2":"En-z","tupacMain":"Fn-z","tupacMain2":"Gn-z"};